import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceTypeOrderPopupComponent } from 'src/app/chart-popup/service-type-order-popup/service-type-order-popup.component';
import { ResponseData } from 'src/app/service/model/response.model';

@Component({
  selector: 'app-service-type-current-year',
  templateUrl: './service-type-current-year.component.html',
  styleUrls: ['./service-type-current-year.component.scss']
})
export class ServiceTypeCurrentYearComponent {

  @Input() item!: ResponseData;
  currentYear = new Date("YYYY");
  // public barChartOptions: any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
  // };

    public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 8,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };
  chartData: number[] = [];
  public barChartLabels: string[] = []
  public barChartData: any[] = [];

  public barChartType: string = 'bar';
  //public barChartLegend:boolean = true;

  public barChartColors: Array<any> = [
    {
      backgroundColor: '#74acac',
      borderColor: '#346d68',
      pointBackgroundColor: 'rgba(105,159,177,1)',
      pointBorderColor: '#fafafa',
      pointHoverBackgroundColor: '#fafafa',
      pointHoverBorderColor: 'rgba(105,159,177)'
    }
  ];
  constructor(private modalService: NgbModal) { }

  ngAfterViewInit() {
    this.CreateChart();
  }

  CreateChart() {
    for (let i = 0; i < this.item.data.dashboardServiceTypeOrdersChart.length; i++) {

      this.barChartLabels.push(this.item.data.dashboardServiceTypeOrdersChart[i].serviceName)
      this.chartData.push(this.item.data.dashboardServiceTypeOrdersChart[i].orderCount)
    }

    this.barChartData = [{ data: this.chartData, label: (new Date()).getFullYear() }];

  }


  OpenPopUp() {


    const modalRef = this.modalService.open(ServiceTypeOrderPopupComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    (modalRef.componentInstance as ServiceTypeOrderPopupComponent).defaultChartData = this.item.data.dashboardServiceTypeOrdersChart;

    modalRef.result.then((result) => {
      console.log(result);


    });

  }


  // events
  public chartClicked(e: any): void {
    // console.log(e);
  }

  public chartHovered(e: any): void {
    //console.log(e);
  }

}
